import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiListGenerated = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "ai list generated ",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 19.1479C2.25 18.7337 2.58579 18.3979 3 18.3979H10.1176C10.5318 18.3979 10.8676 18.7337 10.8676 19.1479C10.8676 19.5622 10.5318 19.8979 10.1176 19.8979H3C2.58579 19.8979 2.25 19.5622 2.25 19.1479Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 14.3828C2.25 13.9686 2.58579 13.6328 3 13.6328H7.43225C7.84647 13.6328 8.18225 13.9686 8.18225 14.3828C8.18225 14.797 7.84647 15.1328 7.43225 15.1328H3C2.58579 15.1328 2.25 14.797 2.25 14.3828Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 4.85156C2.25 4.43735 2.58579 4.10156 3 4.10156H20.9992C21.4134 4.10156 21.7492 4.43735 21.7492 4.85156C21.7492 5.26578 21.4134 5.60156 20.9992 5.60156H3C2.58579 5.60156 2.25 5.26578 2.25 4.85156Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 9.61719C2.25 9.20297 2.58579 8.86719 3 8.86719H10.0111C10.4253 8.86719 10.7611 9.20297 10.7611 9.61719C10.7611 10.0314 10.4253 10.3672 10.0111 10.3672H3C2.58579 10.3672 2.25 10.0314 2.25 9.61719Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5117 18.369C14.1978 18.369 13.917 18.1735 13.8082 17.879L13.6629 17.4858C13.191 16.2084 12.1855 15.2016 10.9106 14.7292L10.518 14.5837C10.2239 14.4747 10.0287 14.1942 10.0287 13.8805C10.0287 13.5668 10.2239 13.2862 10.518 13.1772L10.9106 13.0317C12.1854 12.5593 13.1909 11.5526 13.6629 10.2752C13.6629 10.2752 13.6629 10.2752 13.6629 10.2752L13.8082 9.88197C13.917 9.58747 14.1978 9.39191 14.5117 9.39191C14.8257 9.39191 15.1064 9.58747 15.2152 9.88197L15.3605 10.2752C15.8325 11.5526 16.838 12.5593 18.1128 13.0317C18.1128 13.0317 18.1128 13.0317 18.1128 13.0317L18.5055 13.1772C18.7996 13.2862 18.9949 13.5668 18.9949 13.8805C18.9949 14.1942 18.7996 14.4748 18.5055 14.5838L18.1128 14.7292C18.1129 14.7292 18.1128 14.7292 18.1128 14.7292C16.838 15.2016 15.8325 16.2084 15.3605 17.4858L15.2152 17.879C15.1064 18.1735 14.8257 18.369 14.5117 18.369ZM16.459 13.8805C15.6714 13.3863 15.0054 12.7196 14.5117 11.9313C14.018 12.7196 13.3521 13.3863 12.5645 13.8805C13.3521 14.3747 14.018 15.0414 14.5117 15.8297C15.0054 15.0414 15.6714 14.3747 16.459 13.8805Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.8225 19.897C19.4923 19.897 19.2009 19.681 19.1049 19.3651C19.0058 19.0392 18.7514 18.7848 18.4271 18.6859C18.1115 18.5897 17.8958 18.2985 17.8958 17.9685C17.8958 17.6385 18.1115 17.3473 18.4271 17.2511C18.7514 17.1523 19.0058 16.8978 19.1049 16.572C19.2009 16.256 19.4923 16.0401 19.8225 16.0401C20.1527 16.0401 20.444 16.256 20.5401 16.572C20.6391 16.8978 20.8935 17.1523 21.2178 17.2511C21.5335 17.3473 21.7491 17.6385 21.7491 17.9685C21.7491 18.2985 21.5335 18.5897 21.2178 18.6859C20.8935 18.7848 20.6391 19.0392 20.5401 19.3651C20.444 19.681 20.1527 19.897 19.8225 19.897Z",
			fill: "currentColor"
		})
	]
});
export default SvgAiListGenerated;
